import { render } from "./ReferencePrescriberModal.vue?vue&type=template&id=5ac2ab27"
import script from "./ReferencePrescriberModal.vue?vue&type=script&lang=js"
export * from "./ReferencePrescriberModal.vue?vue&type=script&lang=js"

import "./ReferencePrescriberModal.vue?vue&type=style&index=0&id=5ac2ab27&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__